import { GroupDto, GroupsApi} from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useGetGroup = (
  groupsApi: GroupsApi,
  groupId: string,
  options?: Omit<
    UseQueryOptions<GroupDto, ErrorResponse>,
    "queryKey" | "queryFn"
  >,
): UseQueryResult<GroupDto> => {
  const tenantId = localStorage.getItem('tenantId') as string;

  return useQuery(
    [`group-${groupId}`],
    async () => groupsApi.getGroup(tenantId, groupId).then(({ data }) => data),
    options,
  );
};
